import React, { useContext, useEffect } from 'react';
import { Context } from '../src/services/auth';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Home from './Pages/Home';
import ForgotPassword from './Pages/ForgotPassword';
import FirstAccess from './Pages/FirstAccess';
import Interna from './Pages/Interna';
import MeuPerfil from './Pages/MeuPerfil';
import ChangeEmail from './Pages/ChangeEmail';
import ChangePassword from './Pages/ChangePassword';
import AtualizarPerfil from './Pages/AtualizarPerfil';
import Solicitacoes from './Pages/Solicitacoes';
import NovaSolicitacao from './Pages/NovaSolicitacao';
import MeAjuda from './Pages/MeAjuda';
import AcompanharSolicitacao from './Pages/AcompanharSolicitacao';
import AcompanharAgendamentos from './Pages/Agendamentos';
import Calendario from './Pages/Calendario';
import MeuImovel from './Pages/MeuImovel';
import Destaques from './Pages/Destaques';
import Financeiro from './Pages/Financeiro';
import Pdf from './Pages/Pdf';

import portalEnvironment from './Utils/baseURL';

import Testes from './Pages/Testes';

import ReactGA from 'react-ga';

import SindicoPage from './Pages/Sindico/Identificacao';
import NovaSolicitacaoSindico from './Pages/Sindico/NovaSolicitacaoSindico';
import SolicitacoesSindico from './Pages/Sindico/SolicitacoesSindico';
import AcompanharSolicitacaoSindico from './Pages/Sindico/AcompanhamentoSolicitacaoSindico';

import NeedHelpForm from './Pages/NeedHelpForm';
import HomeSindico from './Pages/Sindico/HomeSindico';
import DocumentosSindico from './Pages/Sindico/DocumentosSindico';

const PrivateRouter = ({ component: Component, ...rest }) => {
  //verificação se usuário está autenticado ou não para acesso à rotas privadas
  const { authenticated } = useContext(Context);

  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
};

const Routes = () => {
  useEffect(() => {
    if (portalEnvironment.environment === 'prod') {
      ReactGA.initialize('UA-156174245-5');
      ReactGA.pageview(location.pathname + location.search);
    }
  });

  return (
    <Switch>
      <Route exact path='/' component={() => <Home />} />

      <Route
        exact
        path='/esqueceu-senha'
        component={() => <ForgotPassword />}
      />
      <Route exact path='/primeiro-acesso' component={() => <FirstAccess />} />
      <PrivateRouter exact path='/interna' component={Interna} />
      <PrivateRouter exact path='/meu-perfil' component={() => <MeuPerfil />} />
      <PrivateRouter
        exact
        path='/atualizar-perfil'
        component={() => <AtualizarPerfil />}
      />

      <PrivateRouter
        exact
        path='/alterar-email'
        component={() => <ChangeEmail />}
      />

      <PrivateRouter
        exact
        path='/alterar-senha'
        component={() => <ChangePassword />}
      />

      <PrivateRouter
        exact
        path='/solicitacoes'
        component={() => <Solicitacoes />}
      />

      <PrivateRouter
        exact
        path='/solicitacoes/nova-solicitacao'
        component={() => <NovaSolicitacao />}
      />

      <PrivateRouter
        path='/solicitacoes/acompanhar-solicitacao/:id'
        exact
        component={AcompanharSolicitacao}
      />

      <PrivateRouter
        path='/solicitacoes/acompanhar-agendamentos'
        exact
        component={() => <AcompanharAgendamentos />}
      />

      <PrivateRouter
        path='/solicitacoes/calendario'
        exact
        component={() => <Calendario />}
      />

      <Route path='/testes' exact component={() => <Testes />} />

      <PrivateRouter exact path='/meu-imovel' component={MeuImovel} />

      <PrivateRouter path='/pdf' exact component={Pdf} />

      <PrivateRouter exact path='/destaques' component={Destaques} />

      <PrivateRouter exact path='/me-ajuda' component={() => <MeAjuda />} />

      <Route
        exact
        path='/precisa-de-ajuda'
        component={() => <NeedHelpForm />}
      />

      <PrivateRouter exact path='/financeiro' component={Financeiro} />

      {/* identificação di síndico */}
      <Route exact path='/sindico' component={SindicoPage} />

      <Route exact path='/sindico/inicio' component={HomeSindico} />

      <Route exact path='/sindico/documentos' component={DocumentosSindico} />

      {/* lista de todos solicitações abertas pelo síndico */}
      <Route
        path='/sindico/solicitacoes-abertas'
        component={SolicitacoesSindico}
      />

      {/* criação de novas solicitações */}
      <Route
        path='/sindico/nova-solicitacao'
        component={NovaSolicitacaoSindico}
      />

      {/* acompanhar solicitação especifica */}
      <Route
        path='/sindico/acompanhar-solicitacao/:id'
        component={AcompanharSolicitacaoSindico}
      />

      <Route path='*' component={() => <h1>Page not found</h1>} />
    </Switch>
  );
};

export default withRouter(Routes);
